
import { FreeResponseDisplay } from "../free-response/FreeResponseDisplay";
import { DragDropGame } from "../DragDropGame";
import { LinkingGame } from "../LinkingGame";

interface InteractiveContentViewerProps {
  type: 'free_response' | 'drag_drop' | 'linking';
  fileId: string;
  resourceId: string;
  onComplete?: () => void;
  onGameUpdate?: (fileId: string, attempt: any) => Promise<void>;
}

export function InteractiveContentViewer({
  type,
  fileId,
  resourceId,
  onComplete,
  onGameUpdate
}: InteractiveContentViewerProps) {
  switch (type) {
    case 'free_response':
      return (
        <div className="w-full max-w-none px-6">
          <FreeResponseDisplay
            fileId={fileId}
            resourceId={resourceId}
            onComplete={onComplete}
          />
        </div>
      );
    
    case 'drag_drop':
      return (
        <div className="w-full max-w-none px-6">
          <DragDropGame
            fileId={fileId}
            resourceId={resourceId}
            onComplete={onComplete}
            onGameUpdate={onGameUpdate ? (attempt) => onGameUpdate(fileId, attempt) : undefined}
          />
        </div>
      );
    
    case 'linking':
      return (
        <div className="w-full max-w-none px-6">
          <LinkingGame
            fileId={fileId}
            resourceId={resourceId}
            onComplete={onComplete}
          />
        </div>
      );
      
    default:
      return null;
  }
}
